module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgBAMAAAAQtmoLAAAAIVBMVEUAAAD////////////////////////////////////////PIev5AAAACnRSTlMAIeHDDQsaiW724QuKWgAAAE5JREFUWMPt1TENACAMRNESHLDggRl2JCABKfXChEs0HCRM/xn46dCcAQC+ytMkobhJ0upioBIgQEANxC2/cjP1hkGCBIn3hOs7DQC4cADr6RvSkLg/xwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/white_back_ic.png
// module id = MgRD
// module chunks = 0